import { Box, Tab, Tabs } from '@mui/material/';
import React from 'react';

import TabPanel from '../atoms/TabPanel';

interface Props {
	tabsNames: Array<string | React.ReactNode>;
	tabs: React.ReactNode[];
	background?: string;
	width?: string;
	height?: string;
	initialTab?: number;
	value?: number;
	onChange?: (event: React.SyntheticEvent, newValue: number) => void;
	tabsCounts?: number[];
}

function props(index: number) {
	return {
		id: `simple-tab-${index}`,
		'aria-controls': `simple-tabpanel-${index}`,
	};
}

const BasicTabs = ({
	tabsNames,
	tabs,
	background = 'white',
	width = '100%',
	height = '98%',
	initialTab = 0,
	value: controlledValue,
	onChange,
	tabsCounts,
}: Props) => {
	const [internalValue, setInternalValue] = React.useState(initialTab);
	const isControlled = controlledValue !== undefined;
	const value = isControlled ? controlledValue : internalValue;

	const handleChange = (event: React.SyntheticEvent, newValue: number) => {
		if (!isControlled) {
			setInternalValue(newValue);
		}
		if (onChange) {
			onChange(event, newValue);
		}
	};

	return (
		<Box
			sx={{
				height,
				marginTop: '1rem',
				background,
				borderRadius: '0.5rem',
				width,
				overflowX: 'auto',
			}}
		>
			<Box sx={{ borderBottom: 1, borderColor: 'divider', width }}>
				<Tabs
					value={value}
					onChange={handleChange}
					aria-label="tabs"
					TabIndicatorProps={{
						style: { backgroundColor: '#193CB9' },
					}}
					variant="scrollable"
					scrollButtons={false}
				>
					{tabsNames.map((el, index) => {
						return (
							<Tab
								key={index}
								style={{
									color: value === index ? '#193CB9' : '#4A4A4A',
									fontSize: '12px',
									lineHeight: '9.5px',
									fontWeight: '500',
									fontFamily: 'inherit',
								}}
								label={
									<div className="flex items-center">
										{el}{' '}
										{typeof tabsCounts?.[index] === 'number' && (
											<span className="ml-[10px] rounded bg-[#CAD5FF] px-1.5 py-1 text-primary">
												{tabsCounts?.[index]}
											</span>
										)}
									</div>
								}
								{...props(index)}
							/>
						);
					})}
				</Tabs>
			</Box>
			{tabs.map((el, index) => {
				return (
					<TabPanel key={index} value={value} index={index}>
						{el}
					</TabPanel>
				);
			})}
		</Box>
	);
};

export default BasicTabs;
